import { useEffect, useState } from 'react'
import './Donate1Impact.css'

interface TabContent {
  label: string;
  photo: string;
  caption: string;
  credit?: string;
  objectPosition?: string;
  objectPositionDesktop?: string;
}

const tabs: TabContent[] = [
  {
    label: "Community-led Conservation",
    photo: "/images/donations/comm-led-conservation.jpg",
    caption: "We partner with local communities to develop solutions that protect pangolins and other wildlife while supporting sustainable livelihoods.",
    credit: "Photo by Joel Porter",
    objectPosition: "center 30%",
    objectPositionDesktop: "center 30%"
  },
  {
    label: "Education",
    photo: "/images/donations/education.jpg",
    caption: "Because knowledge inspires action, we empower the next generation through education, helping people understand why pangolins matter and how they can protect them.",
    credit: "Photo by Dominic Ogu",
    objectPosition: "center 30%"
  },
  {
    label: "Science",
    photo: "/images/donations/science.jpg",
    caption: "We harness cutting-edge science to drive our conservation work and advance pangolin protection efforts elsewhere.",
    credit: "Photo by Edet Etim",
    objectPosition: "center 35%"
  },
  {
    label: "Training",
    photo: "/images/donations/training.jpg",
    caption: "Support the development of a conservation and research training centre that will provide essential training for the next generation of conservation leaders.",
    credit: "Photo by Joel Porter",
    objectPosition: "center 25%"
  }
];

export function Donate1Impact(): JSX.Element {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const active = tabs[activeIndex];

  useEffect(() => {
    tabs.forEach((tab) => {
      const img = new window.Image();
      img.src = tab.photo;
    });
  }, []);

  const handleTabClick = (index: number) => {
    if (index === activeIndex) return;
    setLoaded(false);
    setActiveIndex(index);
  };

  return (
    <div className="Donate1Impact">
      <p className="Donate1Impact-Eyebrow">WHY PANGOLINS?</p>
      <h2 className="Donate1Impact-Headline">
        Pangolins curl into a ball when threatened, making them tragically easy to catch. Without urgent action, we risk losing over 80 million years of evolutionary history.
      </h2>
      <div className="Donate1Impact-Photo-Wrapper">
        <img
          className={"Donate1Impact-Photo" + (loaded ? " Donate1Impact-Photo-Loaded" : "")}
          src={active.photo}
          alt={active.label}
          onLoad={() => setLoaded(true)}
          style={{
            ["--op-mobile" as any]: active.objectPosition ?? "center",
            ["--op-desktop" as any]: active.objectPositionDesktop ?? active.objectPosition ?? "center",
          }}
        />
        {active.credit && <p className="Donate1Impact-Credit">{active.credit}</p>}
        <div className="Donate1Impact-Tabs">
          {tabs.map((tab, index) => (
            <button
              key={tab.label}
              type="button"
              className={"Donate1Impact-Tab" + (index === activeIndex ? " Donate1Impact-Tab-Active" : "")}
              onClick={() => handleTabClick(index)}
            >
              {tab.label.toUpperCase()}
            </button>
          ))}
        </div>
        <div className="Donate1Impact-Caption">
          <p>{active.caption}</p>
        </div>
      </div>
    </div>
  )
}
